import React, { useState } from 'react'
import MyButton from '../../../../UI/form/MyButton'
import QrCodeIcon from '@mui/icons-material/QrCode';
import LineWeightIcon from '@mui/icons-material/LineWeight';
import MyModal from '../../../../UI/modal/MyModal';
import BoxQr from './BoxQr';

const BoxQrGet = ({ boxId, type }) => {

    const [open, setOpen] = useState(false)

  return (
    <>
        <MyButton
            onClick={e => setOpen(true)}
        >
            {
                type && type === 'barcode' ?
                    <LineWeightIcon />
                :
                    <QrCodeIcon />
            }
        </MyButton>

        <MyModal
            open={open}
            setOpen={setOpen}
            header={
                type && type === 'barcode' ? 
                    'Отримати Щтрих-коди в коробці'
                : 
                    'Отримати QR-коди в коробці'
            }
            disableClickOutside={true}
            content={
                <BoxQr
					boxId={boxId}
                    setOpen={setOpen}
                    type={type}
                />
            }
        />
    </>
  )
}

export default BoxQrGet